export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[520px] md:min-h-[620px] flex items-center pt-16 overflow-hidden bg-background-50">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20cinematic%20composition%20with%20floating%20golden%20film%20strips%20and%20abstract%20spotlight%20beams%20against%20deep%20charcoal%20dark%20background%2C%20warm%20amber%20light%20rays%20creating%20elegant%20atmosphere%2C%20stylized%20movie%20theater%20aesthetic%2C%20high%20contrast%20editorial%20design%2C%20no%20text%2C%20abstract%20geometric%20elements%2C%20luxurious%20gold%20particles&width=1600&height=900&seq=hero-movie-bg&orientation=landscape"
          alt="萝卜影视 - 电影主题视觉"
          className="w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-5 whitespace-nowrap">
              最新电影上线 · 每日更新片库
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-50 leading-tight mb-4">
              萝卜影视 · 你的在线高清影院
            </h1>

            <p className="text-lg md:text-xl text-primary-400/90 font-heading italic mb-6">
              热映大片一网打尽，经典佳片随时重温
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              萝卜影视汇聚海量电影大全，每日同步最新电影上线，实时更新热门电影排行榜。无论是最新院线大片还是经典老片，都能在这里找到高清资源。
              电影在线观看免费高清，告别缓冲烦恼，超清画质带来沉浸式观影体验。我们的片库覆盖动作、科幻、悬疑、喜剧、爱情、动画等全品类，
              每周精选专题为你挖掘宝藏佳片，热门话题社区让影迷互动更精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">2.8万+</div>
                <div className="text-xs text-foreground-500 mt-1">高清片源</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">极速同步</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">全品类覆盖</div>
                <div className="text-xs text-foreground-500 mt-1">13大分类</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#ranking" className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer text-center">
                查看热门榜单
              </a>
              <a href="#topics" className="w-full sm:w-auto px-8 py-3 border border-background-300/60 hover:border-primary-500/50 text-foreground-300 hover:text-primary-400 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer text-center">
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20with%20floating%20golden%20film%20reel%20and%20dramatic%20spotlight%20effects%2C%20warm%20vintage%20movie%20theater%20aesthetic%2C%20art%20deco%20inspired%20geometric%20patterns%2C%20deep%20charcoal%20background%20with%20soft%20amber%20glow%2C%20luxurious%20gold%20accents%2C%20stylized%20abstract%20cinema%20elements%2C%20editorial%20design&width=800&height=1000&seq=hero-movie-visual&orientation=portrait"
                alt="萝卜影视 - 高清电影在线观看"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/50 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}